import { RootStateType } from '../store';

export const selectIsAuthenticated = (state: RootStateType): boolean =>
  state.authenticate.isAuthenticated;
